import { fork, all } from 'redux-saga/effects'

import switchRoleSaga from './switchRoleSaga'
import logoutSaga from './logoutSaga'
import forceLogoutSaga from './forceLogoutSaga'
import processEmailQuerySaga from './processEmailQuerySaga'
import proTrackSubscriptionSaga from 'store/entities/identity/sagas/proTrackSubscriptionSaga'
import unsubscribeProgress from './unsubscribeProgress'
import authLoginSuccess from './authLoginSuccess'
import getIdentityProgressSuccess from './getIdentityProgressSuccess'
import protrackRateSaga from './protrackRateSaga'
import updateProfileSuccess from './updateProfileSuccess'
import uploadAvatar from './uploadAvatar'
import fetchHistoryOnProgressUpdates from './fetchHistoryOnProgressUpdates'
import transferUser from './transferUserToOtherOrg'
import updateNotificationsTime from './updateNotificationsTime'

export default function* identitySaga() {
  yield all([
    fork(switchRoleSaga),
    fork(logoutSaga),
    fork(forceLogoutSaga),
    fork(processEmailQuerySaga),
    fork(proTrackSubscriptionSaga),
    fork(unsubscribeProgress),
    fork(authLoginSuccess),
    fork(getIdentityProgressSuccess),
    fork(protrackRateSaga),
    fork(updateProfileSuccess),
    fork(uploadAvatar),
    fork(fetchHistoryOnProgressUpdates),
    fork(transferUser),
    fork(updateNotificationsTime),
  ])
}
